var render = function render(){var _vm=this,_c=_vm._self._c;return _c({ template: '<div>' + _vm.html + '</div>' },{tag:"component"})
}
var staticRenderFns = []

export { render, staticRenderFns }